module.exports = __webpack_public_path__ + "img/step-8.8f05ba55.jpg";